export interface BusinessCentralConnectConfig {
  integrationPath: string;
  tenantIdParamName: string;
  environmentParamName: string;
  tenantIdStorageKey: string;
  environmentStorageKey: string;
}

export const BUSINESS_CENTRAL_CONNECT_CONFIG: BusinessCentralConnectConfig = {
  integrationPath: "/integration/business-central/connect",
  tenantIdParamName: "bc_tenant_id",
  environmentParamName: "environment",
  tenantIdStorageKey: "bcConnectTenantId",
  environmentStorageKey: "bcConnectEnvironment",
};

export interface BusinessCentralHint {
  tenantId: string | null;
  environment: string | null;
}

export const isBusinessCentralConnectPath = (): boolean => {
  return window.location.pathname.includes(
    BUSINESS_CENTRAL_CONNECT_CONFIG.integrationPath,
  );
};

export const extractAndStoreBusinessCentralHint = (): BusinessCentralHint => {
  const urlParams = new URLSearchParams(window.location.search);
  const tenantId = urlParams.get(
    BUSINESS_CENTRAL_CONNECT_CONFIG.tenantIdParamName,
  );
  const environment = urlParams.get(
    BUSINESS_CENTRAL_CONNECT_CONFIG.environmentParamName,
  );

  if (tenantId) {
    localStorage.setItem(
      BUSINESS_CENTRAL_CONNECT_CONFIG.tenantIdStorageKey,
      tenantId,
    );
  }
  if (environment) {
    localStorage.setItem(
      BUSINESS_CENTRAL_CONNECT_CONFIG.environmentStorageKey,
      environment,
    );
  }

  return { tenantId, environment };
};

export const getStoredBusinessCentralHint = (): BusinessCentralHint => {
  return {
    tenantId: localStorage.getItem(
      BUSINESS_CENTRAL_CONNECT_CONFIG.tenantIdStorageKey,
    ),
    environment: localStorage.getItem(
      BUSINESS_CENTRAL_CONNECT_CONFIG.environmentStorageKey,
    ),
  };
};

export const hasStoredBusinessCentralHint = (): boolean => {
  const { tenantId, environment } = getStoredBusinessCentralHint();
  return Boolean(tenantId || environment);
};

export const clearBusinessCentralHint = (): void => {
  localStorage.removeItem(BUSINESS_CENTRAL_CONNECT_CONFIG.tenantIdStorageKey);
  localStorage.removeItem(
    BUSINESS_CENTRAL_CONNECT_CONFIG.environmentStorageKey,
  );
};
